import '@/components/tiptap-editor/tiptap-ui-primitive/input/input.scss';
import { cn } from '@/lib/tiptap-utils';
import { forwardRef } from 'react';

const Input = forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(function Input({ className, type, ...props }, ref) {
    return (
        <input
            ref={ref}
            type={type}
            className={cn('tiptap-input', className)}
            {...props}
        />
    );
});

Input.displayName = 'Input';

function InputGroup({ className, children, ...props }: React.ComponentProps<'div'>) {
    return (
        <div
            className={cn('tiptap-input-group', className)}
            {...props}
        >
            {children}
        </div>
    );
}

export { Input, InputGroup };
